//Strips the characters that are not allowed in filenames (: / \ * ? " < > |).
//A missing or blank name falls back so "undefined" never ends up in a download.
export const safeFilename = (name, fallback = "Order") => {
  const cleaned = String(name ?? "")
    .replace(/[:/\\*?"<>|]/g, "")
    .trim();
  return cleaned === "" ? fallback : cleaned;
};
